import e from "cors";
import { element } from "prop-types";
import React, { useEffect, useState } from "react";
// import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
    const location = useLocation();
    const [headerClass, setHeaderClass] = useState("sub");
    const [mobileBtn, setMobileBtn] = useState(true);

    // 모바일 메뉴
    const mobileToggle = () => {
        if (mobileBtn) {
            setMobileBtn(false);
        } else {
            setMobileBtn(true);
        }
    };

    // 주소
    useEffect(() => {
        if (location.pathname === "/main/info") {
            setHeaderClass("main");
        } else {
            setHeaderClass("sub");
        }
    }, [location]);

    // 메뉴
    useEffect(() => {
        const menu = document.querySelector("header");
        const gnb = document.querySelector(".gnb");
        const gnbLi = document.querySelectorAll(".depth1 > li");
        const menuBg = document.querySelector("header .depth2-bg");
        const menuA = document.querySelectorAll(".gnb a");
        const menuA2 = document.querySelectorAll(".depth2 a");
        const mobileMenu = document.querySelector(".mobileMenu");

        if (matchMedia("screen and (min-width: 1000px)").matches) {
            // pc 에서
            menu.addEventListener("mouseenter", e => {
                e.currentTarget.classList.add("on");
            });

            menu.addEventListener("mouseleave", e => {
                e.currentTarget.classList.remove("on");
            });

            gnb.addEventListener("mouseenter", e => {
                e.currentTarget.classList.add("on");
                menuBg.classList.add("on");
            });

            gnb.addEventListener("mouseleave", e => {
                e.currentTarget.classList.remove("on");
                menuBg.classList.remove("on");
            });
        } else {
            // 모바일에서
        }

        gnbLi.forEach(element => {
            element.addEventListener("mouseenter", e => {
                e.currentTarget.classList.add("on");
            });
            element.addEventListener("mouseleave", e => {
                e.currentTarget.classList.remove("on");
            });
        });

        menuA.forEach(element => {
            element.addEventListener("click", () => {
                // e.preventdefault();
                menu.classList.remove("on");
                gnb.classList.remove("on");
            });
        });

        menuA2.forEach(element => {
            element.addEventListener("click", () => {
                setMobileBtn(true);
                mobileMenu.classList.remove("on");
            });
        });
    }, []);

    // if (location.pathname === "/main/info") {
    //     return (
    //         <header>
    //             <h1>홈 해더</h1>
    //             <nav>
    //                 <ul>
    //                     <li>
    //                         <Link to="/company/info">회사소개</Link>
    //                     </li>
    //                     <li>
    //                         <Link to="/notice/list">공지사항</Link>
    //                     </li>
    //                 </ul>
    //             </nav>
    //         </header>
    //     );
    // }

    return (
        <header className={headerClass}>
            <div className="inner">
                <h1 className="logo">
                    <Link to="/">kt Mos 북구</Link>
                </h1>

                <div onClick={mobileToggle} className={mobileBtn ? "mobileMenu" : "mobileMenu on"}>
                    <button type="button">모바일 메뉴</button>
                </div>

                <nav className="gnb">
                    <ul className="depth1">
                        <li>
                            <Link to="/company/ceo">회사소개</Link>
                            {/* <a href="#">회사소개</a> */}
                            <ul className="depth2">
                                <li>
                                    <Link to="/company/ceo">CEO 인사말</Link>
                                </li>
                                <li>
                                    <Link to="/company/vision">비전</Link>
                                </li>
                                <li>
                                    <Link to="/company/history">연혁</Link>
                                </li>
                                <li>
                                    <Link to="/company/organization">권역도</Link>
                                </li>
                                <li>
                                    <Link to="/company/direction">오시는 길</Link>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <Link to="/business/major">사업소개</Link>
                            {/* <a href="#">사업소개</a> */}
                            <ul className="depth2">
                                <li>
                                    <Link to="/business/major">주요사업</Link>
                                </li>
                                <li>
                                    <Link to="/business/result">사업실적</Link>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <Link to="/promotion/board/list">홍보센터</Link>
                            {/* <a href="#">홍보센터</a> */}
                            <ul className="depth2">
                                <li>
                                    <Link to="/promotion/board/list">공시/홍보</Link>
                                </li>
                                <li>
                                    <Link to="/promotion/esg">ESG 경영</Link>
                                </li>
                                <li>
                                    <Link to="/promotion/board_safety/list">안전보건</Link>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <Link to="/recruit/person">인재채용</Link>
                            {/* <a href="#">인재채용</a> */}
                            <ul className="depth2">
                                <li>
                                    <Link to="/recruit/person">인재상</Link>
                                </li>
                                <li>
                                    <Link to="/recruit/guide">채용안내</Link>
                                </li>
                                <li>
                                    <Link to="/recruit/welfare">복리후생</Link>
                                </li>
                                <li>
                                    <Link to="/recruit/introduction">직무소개</Link>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <Link to="/management/management">윤리경영</Link>
                            {/* <a href="#">윤리경영</a> */}
                            <ul className="depth2">
                                <li>
                                    <Link to="/management/management">윤리경영</Link>
                                </li>
                                <li>
                                    <Link to="/management/anticorruption">부패방지</Link>
                                </li>
                            </ul>
                        </li>
                        {/* <li>
                            <Link to="/notice/list">공지사항</Link>
                        </li> */}
                    </ul>
                </nav>
            </div>
            <div className="depth2-bg"></div>
        </header>
    );
};

export default Header;
